import type { EntryViewT } from "@/types/database/entries";
import useExtractObservation from "./useExtractObservation";

export function extractObservationEntryById(
	entriesView: EntryViewT[],
	entryId: string,
): EntryViewT | undefined {
	return entriesView?.find((m) => m.entry_id === entryId);
}

const useExtractObservationEntry = (
	diaryId: string,
	observationId: string,
	entryId: string,
) => {
	const observation = useExtractObservation(diaryId, observationId);
	const entry = extractObservationEntryById(
		observation?.entries_view ?? [],
		entryId,
	);

	return entry;
};

export default useExtractObservationEntry;
